/** Max characters for module list/search fields. */
export const SEARCH_MAX_LENGTH = 50;

/** No leading spaces; spaces allowed once the user has typed text. */
export function normalizeSearchInput(value) {
  const withoutLeadingSpace = String(value ?? "").replace(/^\s+/, "");
  return withoutLeadingSpace.slice(0, SEARCH_MAX_LENGTH);
}

export function normalizePastedSearchInput(value) {
  const trimmed = String(value ?? "").trim();
  const mobileLike = /^[+\d\s-]+$/.test(trimmed) && /\d/.test(trimmed);
  const normalized = mobileLike ? trimmed.replace(/[^\d+]/g, "") : trimmed;
  return normalized.slice(0, SEARCH_MAX_LENGTH);
}
